import { FC } from 'react';
import { Icon, Tooltip } from '@servicetitan/anvil2';
import { TableCellProps } from '@servicetitan/design-system';
import WarningIcon from '@servicetitan/anvil2/assets/icons/material/round/warning.svg';
import { mainLayoutLocators } from '@locators/main-layout';
import { QueueRow } from './types';
import styles from './QueuesTable.module.css';
import strings from './strings';

/**
 * Module-level component so its identity stays stable across the table's
 * re-renders (driven by RTCS state updates). An inline `cell={(props) => ...}`
 * wrapper would create a new component type per render, remounting the inner
 * Tooltip and causing it to flash on hover.
 *
 * Forwards Kendo's cell props onto the `<td>` so the rendered cell keeps the
 * same className / aria-colindex / aria-selected attributes the default cell
 * produces; tests and a11y selectors rely on these.
 */
const QueueNameCell: FC<TableCellProps> = (props) => {
  const dataItem = props.dataItem as QueueRow;
  return (
    <td
      className={props.className}
      colSpan={props.colSpan}
      style={props.style}
      aria-colindex={props.ariaColumnIndex}
      aria-selected={props.isSelected}
    >
      {dataItem.name}
      {dataItem.hasFallbackWarning && (
        <span className={styles.fallbackWarningIcon}>
          <Tooltip placement='top'>
            <Tooltip.Trigger>
              <Icon
                svg={WarningIcon}
                size='medium'
                color='var(--color-yellow-500)'
                data-testid={
                  mainLayoutLocators.outboundAndTransferModal
                    .queueFallbackWarningIcon
                }
              />
            </Tooltip.Trigger>
            <Tooltip.Content>
              {strings.cells.fallbackWarningTooltip}
            </Tooltip.Content>
          </Tooltip>
        </span>
      )}
    </td>
  );
};

export default QueueNameCell;
